<script>
import SideMenu from "@/components/molecules/side-menu";
import SideMenuItem from "@/components/molecules/side-menu/side-menu-item";
import SideMenuItemGroup from "@/components/molecules/side-menu/side-menu-item-group";
import Divider from "@/components/atoms/divider";

export default {
  name: "MonCompteMenu",
  emits: ["logout"],
  components: { SideMenu, SideMenuItem, SideMenuItemGroup, Divider },
  props: {
    routeActive: {
      type: String,
      required: false,
      default: "/mon-compte"
    },
    isPro: {
      type: Boolean,
      required: false,
      default: false
    },
    isEligibleDefis: {
      type: Boolean,
      required: false,
      default: false
    },
    isEligibleAliasPaiement: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<template>
  <SideMenu
    elevation="md"
    aria-label="Mon compte"
  >
    <div class="u-mr-lg">
      <SideMenuItemGroup>
        <SideMenuItem
          icon-name="user"
          variant-active="primary-lighter"
          :active="routeActive === '/mon-compte'"
          to="/mon-compte"
        >
          Accueil de mon compte
        </SideMenuItem>
        <SideMenuItem
          icon-name="mes-listes"
          variant-active="primary-lighter"
          :active="routeActive.indexOf('/mon-compte/mes-listes-de-courses') === 0"
          to="/mon-compte/mes-listes-de-courses"
        >
          Mes listes
        </SideMenuItem>
        <SideMenuItem
          icon-name="heart"
          variant-active="primary-lighter"
          :active="routeActive === '/mon-compte/mes-produits-habituels'"
          to="/mon-compte/mes-produits-habituels"
        >
          Mes produits habituels
        </SideMenuItem>
        <SideMenuItem
          icon-name="command"
          variant-active="primary-lighter"
          :active="routeActive.indexOf('/mon-compte/mes-commandes') === 0 || routeActive === '/mon-compte/toutes-mes-commandes'"
          to="/mon-compte/mes-commandes"
          separator
        >
          Mes achats <br> et tickets de caisse
        </SideMenuItem>

        <template v-if="!isPro">
          <SideMenuItem
            variant-active="primary-lighter"
            :active="routeActive.indexOf('/mon-compte/abonnements') === 0 || routeActive === '/mon-compte/abonnements'"
            to="/mon-compte/abonnements"
          >
            Mes abonnements
          </SideMenuItem>
          <SideMenuItem
            variant-active="primary-lighter"
            :active="routeActive === '/mon-compte/ma-fidelite'"
            to="/mon-compte/ma-fidelite"
            separator
          >
            Mon espace fidélité
          </SideMenuItem>
        </template>

        <SideMenuItem
          variant-active="primary-lighter"
          :active="routeActive === '/mon-compte/mon-profil'"
          to="/mon-compte/mon-profil"
        >
          Mon profil
        </SideMenuItem>
        <SideMenuItem
          variant-active="primary-lighter"
          :active="routeActive === '/mon-compte/mes-adresses'"
          to="/mon-compte/mes-adresses"
        >
          Mes adresses
        </SideMenuItem>
        <SideMenuItem
          v-if="isEligibleAliasPaiement && !isPro"
          variant-active="primary-lighter"
          :active="routeActive === '/mon-compte/mes-cartes-bancaires'"
          to="/mon-compte/mes-cartes-bancaires"
        >
          Mes cartes bancaires
        </SideMenuItem>
      </SideMenuItemGroup>
    </div>
    <Divider class="u-mt-md u-mb-none" />

    <SideMenuItemGroup>
      <SideMenuItem
        link
        variant="text"
        class="u-pt-sm u-pb-sm"
        @click="$emit('logout')"
      >
        Me déconnecter
      </SideMenuItem>
    </SideMenuItemGroup>
  </SideMenu>
</template>

<style lang="scss" scoped>
</style>
